import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  title?: string;
  message?: string;
}

export function PolicyApplicationLoadingState({ title, message }: LoadingStateProps) {
  return (
    <div className="bg-primary-50 flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 flex justify-center">
          <Loader2 className="text-primary-500 h-12 w-12 animate-spin" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-gray-900">
          {title || 'Loading Policy Application'}
        </h2>
        <p className="text-gray-700">
          {message || 'Please wait while we retrieve your application details...'}
        </p>
      </div>
    </div>
  );
}
